import { PropsWithChildren } from 'react'

import styles from './styles.module.css'

export const Wrapper = ({ children }: PropsWithChildren) => {
  return <main className={styles.wrapper}>{children}</main>
}
